<template>
    <div class="modal-window mbs015">
        <header class="modal-header">
            <div class="tit">{{$i18nUtil.trans("title.ModifyPassword.001","비밀번호 변경")}}</div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>
        <div class="modal-content">
            <div class="box">
                <div class="tit">{{$i18nUtil.trans("message.ModifyPassword.005","현재 비밀번호")}}</div>
                <div class="input-box">
                    <input type="password" id="oriPassword" name="oriPassword" v-model="oriPassword" v-validate="'required'" :placeholder="$i18nUtil.trans('message.placeholder.ModifyPassword.001','현재 비밀번호를 입력해주세요.')" maxlength="10"/>
                    <div class="error-list">
                        <div class="error" v-if="errors.has('oriPassword')">{{$i18nUtil.trans("message.ModifyPassword.006","기존 비밀번호를 입력하세요.")}}</div>
                        <div class="error" v-if="isOriPwMatch === false">{{$i18nUtil.trans("message.ModifyPassword.007","비밀번호가 일치하지 않습니다.")}}</div>
                        <div class="normal" v-if="isOriPwMatch === true">{{$i18nUtil.trans("message.ModifyPassword.008","비밀번호가 확인 되었습니다.")}}</div>
                    </div>
                </div>
                <div class="tit">{{$i18nUtil.trans("message.ModifyPassword.009","새 비밀번호")}}</div>
                <div class="input-box">
                    <input type="password" id="newPassword" name="newPassword" v-model="newPassword" ref="pw" @keyup="passWordValidation" v-validate="'required'" :placeholder="$i18nUtil.trans('message.placeholder.ModifyPassword.002','새 비밀번호를 입력해주세요.')" maxlength="10"/>
                    <div class="error-list">
                        <div class="error" v-if="errors.has('newPassword') ">{{$i18nUtil.trans("message.ModifyPassword.010","비밀번호를 입력하세요.")}}</div>
                        <!-- <div class="error" v-if="validStep1 === false">* 비밀번호를 입력하세요.</div> -->
                        <div class="error" v-if="validStep2 === false">{{$i18nUtil.trans("message.ModifyPassword.011","* 영문/숫자/특수문자 조합하여 8~10자")}}</div>
                        <div class="error" v-if="validStep3 === false">{{$i18nUtil.trans("message.ModifyPassword.012","* 기존 비밀번호와 동일한 설정 제외")}}</div>
                        <div class="error" v-if="validStep4 === false">{{$i18nUtil.trans("message.ModifyPassword.013","* 전화번호와 동일한 설정 제외")}}</div>
                        <div class="normal" v-if="isValidPassword === true">{{$i18nUtil.trans("message.ModifyPassword.014","* 사용할 수 있는 비밀번호 입니다.")}}</div>
                    </div>
                </div>
                <div class="tit">{{$i18nUtil.trans("message.ModifyPassword.015","새 비밀번호 확인")}}</div>
                <div class="input-box">
                    <input type="password" id="confirmPassword" name="confirmPassword" v-model="confirmPassword" @keyup="confirmNewPassword" v-validate="'required'" :placeholder="$i18nUtil.trans('message.placeholder.ModifyPassword.003','새 비밀번호를 다시 한 번 입력해주세요')" maxlength="10"/>
                    <div class="error-list">
                        <div class="error" v-if="errors.has('confirmPassword')">비밀번호를 입력하세요.{{$i18nUtil.trans("message.ModifyPassword.010","비밀번호를 입력하세요.")}}</div>
                        <div class="normal" v-if="isPasswordSame === true">{{$i18nUtil.trans("message.ModifyPassword.002","* 신규 비밀번호와 일치")}}</div>
                        <div class="error" v-if="isPasswordSame === false">{{$i18nUtil.trans("message.ModifyPassword.003","* 신규 비밀번호와 불일치")}}</div>
                    </div>
                </div>
            </div>
        </div>

        <footer class="modal-footer">
            <button type="button" class="btn_ty1" @click="modifyPassword">{{$i18nUtil.trans("button.save","저장")}}</button>
        </footer>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
    components: {
    },
    props : {
        userId : String,
        cellPhoneNo : String
    },
    data() {
        return { 
            /* 기존 비밀번호 */
            oriPassword : "",
            isOriPwMatch : null,
            /* 신규 비밀번호_1 */
            newPassword : "",
            /* 신규 비밀번호_2 */
            confirmPassword : null,
            /* 신규 비밀번호 대조 */
            isPasswordSame : null,
            /* 최종 비밀번호 사용가능 여부 */
            isValidPassword : null,

            validStep1 : null,
            validStep2 : null,
            validStep3 : null,
            validStep4 : null,
        };
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("chkPw", ["chkValidPw"]),
        ...mapActions("modals", ["showDialog"]),
        /* 기존 비밀번호 일치 확인 */
        confirmOriPassword() {
            let obj = this;
            let reqData = {
                url: "/api/auth/org/confirmOriPassword",
                method: "post",
                params: {
                    password: obj.oriPassword,
                    userId : obj.userId,
                },
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
                if(res.errorCode != null) {
                    console.log(res.errorCode);
                    obj.isOriPwMatch = res.result;
                } else {
                    obj.isOriPwMatch = res.result;
                }
            })
            .catch(function (err) {
                console.log(err);
            });
        },
        /* 신규 비밀번호 일치 확인 */
        confirmNewPassword() {
            let newPw = this.newPassword;
            let chkPw = this.confirmPassword;

            if (newPw != chkPw) {
                this.isPasswordSame = false;
            } else {
                this.isPasswordSame = true;
            }
        },
        /* 신규 비밀번호 유효성 검사 */
        async passWordValidation() {
            let obj = this;
            obj.validStep1 = null;
            obj.validStep2 = null;
            obj.validStep3 = null;
            obj.validStep4 = null;

            let pw = obj.newPassword;
            let pwLen = null;
            if(pw != null) {
                pwLen = pw.length;
            }
             
            obj.isValidPassword = false;

            if (pw == "" || pw == 0 || pw == null || pw == undefined) {
                /* 
                chrome 에서는 alert 과 focus 를 동시에 사용시 무한루프가 발생되어 
                해결하기 위해 setTimeout 사용 
                */
                setTimeout(function () {
                    obj.$refs.pw.focus();
                }, 10);
                obj.validStep1 = false;
                return;
            } else {
                obj.validStep1 = true;
            }
            
            if (pwLen < 8 || pwLen > 10) {
                setTimeout(function () {
                    obj.$refs.pw.focus();
                }, 10);
                obj.validStep2 = false;
                return;
            } else {
                obj.validStep2 = true;
            }
            /* 
                패스워드 유효성 검사 
                : 영문 / 숫자 / 특수문자 체크  
            */
            let isValid = await obj.chkValidPw(pw).then((chkVal) => {
                return chkVal;
            });
            if (!isValid) {
                obj.validStep2 = false
                return;
            } else {
                obj.validStep2 = true;
            }
        },
        modifyPassword() {
            let obj = this;
            obj.$validator.validate().then(valid => {
                if(valid) {
                    if(obj.newPassword === obj.confirmPassword) {
                        let reqData = {
                            url : "/api/auth/org/modifyPwByAfterLogin",
                            method : "post",
                            params : {
                                userId : obj.userId,
                                password : obj.newPassword,
                                oriPassword : obj.oriPassword,
                            }
                        };
                        obj
                        .COWORK_REST_SIMPLE_ACTION(reqData)
                        .then(function (res) {
                            if(res.errorCode != null) {
                                let errorCode = res.errorCode;
                                let contents = null;
                                let info = {
                                    title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
                                    button: obj.$i18nUtil.trans("button.dialog.confirm","확인"),
                                    contents: contents
                                };
                                if(errorCode === "AUTH_ORG_NEW_PW_NO_SAME_ORI_PW") {
                                    obj.validStep3 = false;
                                    info.contents = obj.$i18nUtil.trans("UB033")
                                    obj.handleDialog(info);
                                } else if(errorCode === "CONFIRM_CELL_PHONE_NO_NOT_USE_IN_PASSWORD") {
                                    obj.validStep4 = false;
                                    info.contents = obj.$i18nUtil.trans("비밀번호에 핸드폰 번호를 사용할 수 없습니다.")
                                    obj.handleDialog(info);
                                } else if (errorCode === "AUTH_ORG_NOT_MATCH_ORI_PASSWORD" ){
                                    info.contents = obj.$i18nUtil.trans("UB030")
                                    obj.handleDialog(info);
                                }
                            } else {
                                let info = {
                                    title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
                                    contents: obj.$i18nUtil.trans("AG031"),
                                    button: obj.$i18nUtil.trans("button.dialog.confirm","확인"),
                                }
                                obj.handleDialog(info);
                                obj.$emit('close');
                            }
                        })
                        .catch(function (err) {
                            console.log(err);
                        }); 
                    } else {
                        obj.isPasswordSame === false;
                        let info = {
                            title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
                            contents: obj.$i18nUtil.trans("UB041"),
                            button: obj.$i18nUtil.trans("button.dialog.confirm","확인"),
                        }
                        obj.handleDialog(info);
                    }
                }
            });
        },
        handleDialog(info) {
            const dialogInfo = {
                obj: this.$modal,
                component: Dialog,
                title : info.title,
                button : info.button,
                contents : info.contents
            };
            this.showDialog(dialogInfo);
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/common/myInfo/modal/ModifyPassword.vue